__turbopack_context__.v({
  "body": "PhotoModal-module__svsh1G__body",
  "dialog": "PhotoModal-module__svsh1G__dialog",
});
